var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hubspot-fields"},_vm._l((_vm.inputs),function(ref){
var name = ref.name;
var target = ref.target;
var value = ref.value;
return _c('div',{key:name,staticClass:"field",class:name},[_c('label',{attrs:{"for":name}},[_vm._v(_vm._s(name))]),_c('input',{attrs:{"id":name,"type":"text","name":name},domProps:{"value":target ? (_vm.userData[target] ? 'Yes' : 'No') : value}})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }